<template>
  <div>
	  <z-baiduMap></z-baiduMap>
	  <z-sideBar></z-sideBar>
  </div>
  <!-- <router-view></router-view> -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import ZBaiduMap from '@/components/common/BaiduMap.vue'
import ZSideBar from '@/components/common/SideBar.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
    ZBaiduMap,
    ZSideBar
  }
}
</script>
